import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ConfirmButton } from "../components";
import { useFeatureFlag } from "../hooks/useFeatureFlag";

export const AccountNotConnected = () => {
  const history = useHistory();
  const { isEnabled: isSocialSigninEnabled, isLoading } = useFeatureFlag("socialSignin");

  useEffect(() => {
    if (!isLoading && !isSocialSigninEnabled) {
      history.push("/login");
    }
  }, [isLoading, isSocialSigninEnabled, history]);

  const handleBackToLogin = () => {
    history.push("/login");
  };

  if (isLoading || !isSocialSigninEnabled) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Account Not Connected</title>
      </Helmet>
      <div className="px-10 py-10">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-semibold text-gray-800 mb-4">
            We could not sign you in with your Google/Microsoft account.
          </h1>
          <p className="text-gray-600 mb-6">
            Please use your <strong>email address and password</strong> to log in, or confirm that the Google/Microsoft account you selected uses the same email address you use to login to Breathe.
          </p>
        </div>

        <div className="flex justify-center">
          <ConfirmButton onClick={handleBackToLogin} text="Back to Login" />
        </div>
      </div>
    </>
  );
};

